import { render, staticRenderFns } from "./TrainingVideosListing.vue?vue&type=template&id=3fb4135a&scoped=true"
import script from "./TrainingVideosListing.vue?vue&type=script&lang=js"
export * from "./TrainingVideosListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb4135a",
  null
  
)

export default component.exports